import React, {
  PropsWithChildren,
  useEffect,
} from 'react';
import FullScreenSpinner from 'core/components/FullScreenSpinner';
import {
  useAuth,
} from 'core/hooks';
import {
  useImpersonation,
} from 'core/context/impersonation';
import {
  APP_ROUTES,
} from 'views/EMR/router';

export default function ProtectedRouter({ children }: PropsWithChildren) {
  const { isImpersonating } = useImpersonation();
  const {
    issueAccessToken,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    isGoogleOAuth2,
  } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        issueAccessToken();
        if (!isImpersonating && isGoogleOAuth2) {
          window.location.replace(APP_ROUTES.POPULATE_SUPPORT.ROOT);
        }
      } else {
        const targetUrl = `${window.location.pathname}${window.location.search}`;
        loginWithRedirect({ appState: { targetUrl } });
      }
    }
  }, [isAuthenticated, isLoading]);

  return isLoading || !isAuthenticated ? <FullScreenSpinner /> : children;
}
